/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a haiku and check the classic 5-7-5 syllable pattern instantly. Each of the three lines is counted and compared to its target as you type.`)
};

const es_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un haiku y comprueba al instante el clásico patrón de sílabas 5-7-5. Cada una de las tres líneas se cuenta y se compara con su objetivo mientras escribes.`)
};

const de_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibe ein Haiku und prüfe sofort das klassische 5-7-5-Silbenmuster. Jede der drei Zeilen wird während des Tippens gezählt und mit ihrem Zielwert verglichen.`)
};

const nl_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrijf een haiku en controleer direct het klassieke 5-7-5 lettergreeppatroon. Elk van de drie regels wordt geteld en vergeleken met het doel terwijl je typt.`)
};

const fr_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écrivez un haïku et vérifiez instantanément le schéma classique de syllabes 5-7-5. Chacun des trois vers est compté et comparé à son objectif au fur et à mesure que vous tapez.`)
};

const it_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi un haiku e verifica all'istante il classico schema di sillabe 5-7-5. Ciascuna delle tre righe viene contata e confrontata con il suo obiettivo mentre digiti.`)
};

const pt_br2_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva um haiku e verifique instantaneamente o clássico padrão silábico 5-7-5. Cada uma das três linhas é contada e comparada com sua meta enquanto você digita.`)
};

const pt_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva um haiku e verifique instantaneamente o clássico padrão silábico 5-7-5. Cada uma das três linhas é contada e comparada com o seu objetivo à medida que escreve.`)
};

const ja_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句を書きながら、伝統的な5-7-5の音節パターンに合っているかを即座に確認できます。入力するたびに3行それぞれの音節数がカウントされ、目標値と比較されます。`)
};

const zh_syl_haiku_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写下俳句，即时检测是否符合经典的5-7-5音节格式。你在输入时，三行诗句都会分别被统计音节数并与目标数值进行对比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_intro", locale)
	if (locale === "en") return en_syl_haiku_intro(inputs)
	if (locale === "es") return es_syl_haiku_intro(inputs)
	if (locale === "de") return de_syl_haiku_intro(inputs)
	if (locale === "nl") return nl_syl_haiku_intro(inputs)
	if (locale === "fr") return fr_syl_haiku_intro(inputs)
	if (locale === "it") return it_syl_haiku_intro(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_intro(inputs)
	if (locale === "pt") return pt_syl_haiku_intro(inputs)
	if (locale === "ja") return ja_syl_haiku_intro(inputs)
	return zh_syl_haiku_intro(inputs)
};